/* ============================================================
   x-branta-spec-grid-pin — spec-grid 图片/视频钉住 + 文案分批渐入
   仅桌面端（>768px，与 x-branta.css 的断点一致）生效：
   - .x-branta-spec-grid-pin__stage 在 CSS 里是 position:sticky，
     本脚本只负责计算“钉住期间”的滚动进度，不接管定位本身；
   - 钉住期间可滚动的总距离 = pin 整体高度 − stage 自身高度
     （多出来的那部分就是 x-branta.css 里 .x-branta-spec-grid-pin::after
     撑出来的占位，本脚本不需要单独找到那个伪元素，直接用两个真实
     元素的高度差算出来即可）；
   - 进度（0→1）按 data-branta-pin-step（1..N）分批给对应文案加/去
     is-visible，渐入/渐出动画沿用 .x-branta-reveal 在 CSS 里定义的
     transition；
   - 移动端（::after 不生成）total 恒为 0，交还给 x-branta-reveal.js
     的常规逐个元素 IntersectionObserver 处理，本脚本不做任何事。
   ============================================================ */
(function () {
  'use strict';

  var PIN_SELECTOR = '.x-branta-spec-grid-pin';
  var STAGE_SELECTOR = '.x-branta-spec-grid-pin__stage';
  var STEP_ATTR = 'data-branta-pin-step';
  var MQ = window.matchMedia('(min-width: 769px)');

  function clamp(value, min, max) {
    return value < min ? min : value > max ? max : value;
  }

  function setup(pin) {
    if (pin.__brantaPinBound) return;
    pin.__brantaPinBound = true;

    var stage = pin.querySelector(STAGE_SELECTOR);
    var rows = Array.prototype.slice.call(pin.querySelectorAll('[' + STEP_ATTR + ']'));
    if (!stage || !rows.length) return;

    var steps = 0;
    for (var i = 0; i < rows.length; i++) {
      var s = parseInt(rows[i].getAttribute(STEP_ATTR), 10) || 0;
      if (s > steps) steps = s;
    }
    if (!steps) return;

    var activeStep = -1;
    var ticking = false;

    function applyStep(step) {
      if (step === activeStep) return;
      activeStep = step;
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        var s = parseInt(row.getAttribute(STEP_ATTR), 10) || 0;
        if (s <= step) {
          row.classList.add('is-visible');
        } else {
          row.classList.remove('is-visible');
        }
      }
    }

    function update() {
      ticking = false;

      // 移动端：::after 占位不生成，没有额外滚动距离，不做钉住/分批，
      // 全部交给 x-branta-reveal.js
      if (!MQ.matches) {
        if (activeStep !== -1) applyStep(0);
        return;
      }

      var total = pin.offsetHeight - stage.offsetHeight;
      if (total <= 0) return;

      var rect = pin.getBoundingClientRect();
      var progress = clamp(-rect.top / total, 0, 1);
      applyStep(Math.round(progress * steps));
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    MQ.addEventListener('change', update);

    update();
  }

  function init(scope) {
    var root = scope || document;
    var pins = root.querySelectorAll(PIN_SELECTOR);
    for (var i = 0; i < pins.length; i++) setup(pins[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // 主题编辑器中重新加载该 section 时重新绑定
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
